module.exports = __webpack_public_path__ + "static/media/gift-super.867f97bf.svg";